import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Popup from 'reactjs-popup';
import { Modal } from 'react-bootstrap';
import Card_detail from './Card_detail';
import { useNavigate } from "react-router-dom";
import './Popupmsg.css'
import './Card_detail.css'
import { toast } from 'react-toastify';
import ValidateModal from './ValidateModal';
import jskrImg from '../../assets/jskrImg.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'

function Popupmsg({ jobseeker_details, update_table }) {
  const [regno, setregno] = useState("");
  const volunteer = localStorage.getItem("user");
  let id = JSON.parse(volunteer)[0].id;
  let job_id = JSON.parse(volunteer)[0].V_jobfair;
  let company_id = JSON.parse(volunteer)[0].V_companyname;
  const navidate = useNavigate();
  const [cardJobseeker, setCardJobseeker] = useState({});

  //=======================to  store jobseeker to pass database=============================

  const [doAccept, setdoAccept] = useState([{

    "id": "",
    "jobseeker_regno": "",
    "JobfairID": "",
    "CompanyID": "",
    "status": "",
    "reporting_time": "",
    "volunteer": "",
    "updated_by": "",
    "date": "",
    "jobseeker": ""

  }]);
  //=======================To store jobseeker details=============================

  const [Jobseeeker, setJobseeeker] = useState({
    "id": "",
    "jobseeker_regno": "",
    "JobfairID": "",
    "CompanyID": "",
    "status": "",
    "reporting_time": "",
    "volunteer": "",
    "updated_by": null,
    "jobdescription": null,
    "date": "",
    "jobseeker": ""
  })
  //======================= api for getting Jobseeker details with reg_no in popoup =============================

  const getJobseeker = () => {
    setJobseeeker({
      "id": "",
      "jobseeker_regno": "",
      "JobfairID": "",
      "CompanyID": "",
      "status": "",
      "reporting_time": "",
      "volunteer": "",
      "updated_by": null,
      "jobdescription": null,
      "date": "",
      "jobseeker": ""
    })
    if (regno == null || regno == "") {
      toast.error("Enter valid register number")
    }
    else {
      return axios.post('https://pl.aspireitacademy.com/jobseekersearch_with_reg', { "regno": regno })
        .then((response) => {
          if (response.data == null || response.data == '') {
            toast.error("Incorrect Register Number!")
            // alert("")
          } else {

            setJobseeeker(response.data);
            // alert("you must click on search btn")

          }
        }).catch(function (error) {
          toast.error("Something Went Wrong");
        })
    }
  }
  // console.log(getJobseeker);
  useEffect(() => {
    setregno("")
    if (id == null) {
      navidate('/volunteer_login', {
        state: {
          user: volunteer,
        }
      });
    }

  }, []);
  //====================== api for accept  volunteer add jobseeker if only update volntr profile=============================
  const getdoAccept = () => {
    let existing = false;
    jobseeker_details.forEach(element => {
      if (element.id === Jobseeeker.id) {
        existing = true;
      }
    });
    if (existing) {
      toast.error("Existing...");
      return
    }
    if (job_id !== null && company_id !== null) {
      let details = {
        'regno': regno,
        'reporting_time': new Date(),
        'volunteer_id': id
      }
      return axios.put("https://pl.aspireitacademy.com/Volntr_add_jobskr", details).then((response) => {
        setdoAccept(response.data);
        // let AppliedCompanies =[{
        //   'applied_date' : new Date(),
        //   'company': company_id,
        //   'description':   company_id,

        // }]
        let ms = "AppliedCompanies";
        let ms1 = "Candidate doesn't Exists! "
      var msg ={ key :ms};
      var msg1 ={ key :ms1};

        if (response.data !== null && !response.data[ms] && !response.data[ms1])
        {
          if (regno !== null && regno !== "") {
            update_table();
            handleClose();
          }
        }

        else {
          toast.error("Already Applied this Company");
        }
      }).catch(function (error) {
        toast.error("Something Went Wrong");
      })
    }
    else {
      alert("you must update your profile")
    }
  }

  //======================= To display popup =============================
  const [show, setShow] = useState(false);
  const [validateModal, setvalidateModal] = useState(false);
  const [validatepopupshow, setValidatepopupshow] = useState(false);
  const handleClose = () => {
    if (job_id == null || company_id == null) {
      // console.log(job_id);
      alert("you must update your profile")
    }
    setShow(false);
    setJobseeeker(
      {
        "id": "",
        "JobfairID": "",
        "jobseeker_regno": "",
        "CompanyID": "",
        "status": "",
        "reporting_time": "",
        "volunteer": "",
        "updated_by": null,
        "jobdescription": null,
        "date": "",
        "jobseeker": ""
      }
    )

  }

  
         
           
   
  const handleValidatePopupClose = () => {
    setvalidateModal(false);
    setValidatepopupshow(false);
  }

  const handleShow = () => {

    setregno("")
    if (job_id == null || company_id == null) {

      setvalidateModal(true);
      setValidatepopupshow(true);
      //  navidate('/Edit_profile')
    }
    else {
      setShow(true);

    }
  }
  useEffect(() => {
    if (Jobseeeker && Jobseeeker[0]) {
      setCardJobseeker({ ...Jobseeeker[0] })
    } else {
      setCardJobseeker({ ...Jobseeeker })
    }

  }, [Jobseeeker])
  const msg = () => {
    // console.log("insidemsg");
    setshowaccept(true);

  }
  const [showaccept, setshowaccept] = useState(true);

  return (
    <>
      {validateModal && < ValidateModal
        handleClick={handleValidatePopupClose}
        validatepopupshow={validatepopupshow}
      />}

      <div style={{ display: "flex", flexDirection: "row-reverse" }}>
        <div className="m-2" >
          <button type="submit" className="btn btn-primary " active onClick={() => handleShow()} id='volsavebtn'>
            <i class="fa fa-user-plus" aria-hidden="true"></i>  Add Jobseeker</button>

        </div>
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} dialogClassName="my-modal">
          <Modal.Header closeButton style={{ borderBottom: '0px' }}>
          </Modal.Header>
          <Modal.Body className='mb-3' >
            <div className='container  d-sm-flex ' >
              <img src={jskrImg} alt="img" width="130px" height="130px"
                className="rounded-circle mb-2" />

              <div className='ms-3 container-fluid'>
                <h6 className='mb-2 fgt-title'>Jobseeker</h6>
                <div className='both' style={{ display: "inline-flex" }}>
                  <div className='search_bar' style={{ paddingTop: "10px" }}>
                    <input name="text" id='fgt-input'
                      type="number" onChange={(e) => setregno(e.target.value)}
                      placeholder="Enter Register number:" required="required"
                      className="form-control w-100  mb-3" autoFocus />
                  </div>

                  <div className="m-3" style={{ display: "inline" }}>
                    <button  className="btn btn-primary " id='volsavebtn' onClick={() => getJobseeker()}>
                      <FontAwesomeIcon icon={faMagnifyingGlass}  /></button>
                  </div>
                </div>
                <Card_detail Jobseeeker={cardJobseeker} />
                <div className='button' style={{paddingLeft:"5pc",}}>
                <div className="m-2" style={{ display: "inline" }}>
                  <button type="close" id='volsavebtn' className="btn btn-primary" style={{ backgroundColor: "white", borderColor: "#2fba19", color: "#111d30",position:"absolute" }} onClick={handleClose} >Close</button>

                </div>
                <div className="m-2" style={{ display: "inline", paddingLeft: "5rem", }} >
              
{     
showaccept&&       
  <button type="submit" disabled ={!cardJobseeker.id} id='volsavebtn' className="btn btn-primary" style={{ backgroundColor: "#111d30", borderColor: "#2fba19", color: "white", }} onClick={() => getdoAccept()} >Accept</button>
}
                </div> 
                </div>
              </div>


            </div>
          </Modal.Body>
        </Modal>
        <Popup
          position="right">
        </Popup>
      </div>
    </>
  )
};
export default Popupmsg;